const initialState = {
  category: {},
  product: {},
};
const entities = (state = initialState) => {
  return state;
};

export default entities;
